import axios, { AxiosInstance, InternalAxiosRequestConfig } from 'axios'
import { useAuthStore } from '@/stores/auth'

const baseURL = import.meta.env.VITE_API_BASE || '/api/v1'

export const http: AxiosInstance = axios.create({
  baseURL,
  withCredentials: true,
  timeout: 30000,
})

http.interceptors.request.use((config: InternalAxiosRequestConfig) => {
  const auth = useAuthStore.getState()
  if (auth.csrf) {
    config.headers['X-CSRF-Token'] = auth.csrf
  }
  return config
})

http.interceptors.response.use(
  (resp) => {
    const body = resp.data
    if (body && typeof body === 'object' && 'code' in body && 'data' in body) {
      return body.data
    }
    return body
  },
  (err) => {
    const status = err?.response?.status
    if (status === 401) {
      // 只做本地清理，不能再调 logout()：logout 会 POST /auth/logout，
      // 会话已失效时该请求同样 401，会经拦截器无限循环。路由守卫会接管跳登录页。
      useAuthStore.getState().clearLocal()
    }
    return Promise.reject(err)
  },
)
